import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CreateTeamForm from 'components/team/CreateTeamForm';
import StyledModal from 'components/modal/StyledModal';
import { createTeam } from 'actions/Team';
import createModalConnector from './createModalConnector';

import { clearModal } from 'actions';

const CreateTeamModal = ({ modalOpen, clearModal, createTeam }) => {
  const clearModalCallback = clearModal.bind(null, 'CREATE_TEAM');

  return (
    <StyledModal
      isOpen={modalOpen}
      toggle={clearModalCallback}
      title={'Create Team'}
    >
      <CreateTeamForm onSubmit={createTeam} onCancel={clearModalCallback} />
    </StyledModal>
  );
};

CreateTeamModal.propTypes = {
  clearModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  createTeam: PropTypes.func,
};

export default connect(createModalConnector('CREATE_TEAM'), {
  clearModal,
  createTeam,
})(CreateTeamModal);
